module.exports = __webpack_public_path__ + "img/bp_title2.2ad857bf.png";